import { render, staticRenderFns } from "./PastEmployeeHistory.vue?vue&type=template&id=c9def860&"
import script from "./PastEmployeeHistory.vue?vue&type=script&lang=js&"
export * from "./PastEmployeeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports